module.exports = __webpack_public_path__ + "img/soundTutorial2.8407faee.png";